<template>
  <div>
    <!-- toast-container: {{this.toastNotification.isVisible}} store: {{this.$store.getters['toastNotification/isVisible']}} -->
    <div style="position: fixed;" id="toast-container" v-show="toastNotification.isVisible">
      <div class="toast-container" v-bind:class="[this.getCss(this.toastNotification.statusCode)]">
        <p class="toast-container-text">{{this.toastNotification.message}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { toastNotificationComputed, toastNotificationMethods, toastNotificationMutations } from "@/state/helpers";
export default {
  name: "Loader",
  data() {
    return {
      key: "value"
    };
  },
  methods: {
    ...toastNotificationMethods,
    ...toastNotificationMutations,
    name() {},
    getCss(statusCode) {
      switch (statusCode) {
        case 0:
          return "toast-error";
        case 1:
          return "toast-success";
        default:
          return "toast-info";
      }
    }
  },
  computed: {
    ...toastNotificationComputed
  },
  mounted() {
    //console.log(" notification ", this.toastNotification, " visible: ", this.toastNotification.isVisible);
  }
};
</script>

<style scoped>
#toast-container {
  background: #e1e1e1;
  height: 40px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 505;
}
.toast-container {
  display: block;
  text-align: center;
  height: 40px;
}
.toast-container-text {
  padding-top: 0px;
  margin: 0 0 1.3em;
  text-align: center;
  /* color: #383d41; */
  line-height: 35px;
  font-weight: 600;
}
.toast-error {
  background: #f8d7da;
  color: #721c24;
}
.toast-success {
  background: #d4edda;
  color: #155724;
}
.toast-info {
  background: #e2e3e5;
  color: #1b1e21;
}
</style>